import { Search } from 'lucide-react'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { AppBreadcrumbs } from '@/components/layout/AppBreadcrumbs'
import { NotificationsDropdown } from '@/components/layout/NotificationsDropdown'
import { Input } from '@/components/ui/input'
import { Separator } from '@/components/ui/separator'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { useDashboardSearch } from '@/contexts/DashboardSearchContext'

export function TopBar() {
  const { searchQuery, setSearchQuery } = useDashboardSearch()
  const { pathname } = useLocation()
  const isDashboard = pathname === '/dashboard'

  useEffect(() => {
    if (!isDashboard && searchQuery) setSearchQuery('')
  }, [isDashboard, searchQuery, setSearchQuery])

  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b bg-background px-4">
      <SidebarTrigger className="-ml-1" />
      <Separator orientation="vertical" className="mr-2 h-4" />

      {isDashboard ? (
        <div className="relative min-w-0 max-w-sm flex-1">
          <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            type="search"
            aria-label="Search agents"
            placeholder="Search agents..."
            value={searchQuery}
            onChange={(event) => setSearchQuery(event.target.value)}
            className="h-9 rounded-full bg-secondary/60 pl-9 shadow-none"
          />
        </div>
      ) : (
        <AppBreadcrumbs />
      )}

      <div className="ml-auto flex items-center gap-3">
        <NotificationsDropdown />
      </div>
    </header>
  )
}
